import { render, staticRenderFns } from "./chatHistory.vue?vue&type=template&id=2c8e5ce4&scoped=true"
import script from "./chatHistory.vue?vue&type=script&lang=ts"
export * from "./chatHistory.vue?vue&type=script&lang=ts"
import style0 from "./chatHistory.vue?vue&type=style&index=0&id=2c8e5ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8e5ce4",
  null
  
)

export default component.exports